import SimpleBar from 'simplebar';
import ComponentElement from 'components/component-element';
import 'simplebar/dist/simplebar.css';
import {createElement} from 'methods/utils';

function Select($element, options = {}) {
    // ссылка на экземпляр
    if ($element._select) {
        return $element._select;
    }
    $element._select = this;

    ComponentElement.call(this, $element, options);

    this.$element      = $element;
    this.$input        = this.$element.querySelector('input[type="hidden"]');
    this.$selected     = this.$element.querySelector('.Select-selected');
    this.$itemsWrapper = this.$element.querySelector('.Select-items');
    this.$items        = this.$element.getElementsByClassName('Select-item');

    this._initHiddenInput();

    // if (options.initSelectIndex == 0) {
    //     // игнорируем инициализацию значения по умолчанию
    // } else {
        this._initSelectedIndex();
    // }
    this._initSimpleBar();

    // открытие элемента
    this.$element.addEventListener('click', e => {
        // e.stopPropagation();
        this.toggle();
    });

    // инициализация встроенных элементов
    [...this.$items].forEach($item => {
        this._initItem($item);
    });

    Object.defineProperty(this.$element, 'value', {
        enumerable: true,
        get: this.getValue.bind(this),
        set: this.setValue.bind(this),
    });

    Object.defineProperty(this.$element, 'selectedIndex', {
        enumerable: true,
        get: this.getSelectedIndex.bind(this),
        set: this.setSelectedIndex.bind(this),
    });

    Object.defineProperty(this.$element, 'options', {
        enumerable: true,
        get: this.getItems.bind(this),
    });

    // для плавных анимаций
    this.$element.classList.add('is-initialized');

    setTimeout(() => {
        this.emit('ready', this._value, this._selectedIndex);
    });
}

Select.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Select.prototype, 'constructor', {
    value: Select,
    enumerable: false,
    writable: true,
});

Select.prototype.getItems = function() {
    return [...this.$items];
}

Select.prototype.setItems = function(items) {
    // очистка списка
    const $wrapper = this._getItemsWrapper();
    while ($wrapper.lastElementChild) {
        $wrapper.removeChild($wrapper.lastElementChild);
    }

    // собираем контент
    items.forEach(item => {
        this.addItem(item.title, item.value);
    });
}

/**
 * Добавление элемента
 * @param {String} title Текст
 * @param {String} value Значение
 */
Select.prototype.addItem = function(title, value) {
    const $item = createElement(
        `<div class="Select-item" data-value="${value}">${title}</div>`
    );

    const $wrapper = this._getItemsWrapper()
    $wrapper.appendChild($item);

    this._initItem($item);
}

/**
 * Инициализация элемента, обработчики
 * @param {Element} $item HTML элемент
 */
Select.prototype._initItem = function($item) {
    $item.addEventListener('click', e => {
        e.stopPropagation();
        this._itemClick($item);
    });
}

/**
 * Контейнер для элементов, может быть внутри simplebar
 * @return Element
 */
Select.prototype._getItemsWrapper = function() {
    return (this._simpleBar && this._simpleBar.contentEl) ? this._simpleBar.contentEl : this.$itemsWrapper;
}

Select.prototype.getSelectedItem = function() {
    return this.getItems()[this.getSelectedIndex()];
}

/**
 * Получение значения
 */
Select.prototype.getValue = function() {
    return this._value;
}

/**
 * Установка значения
 * @param {Number}  value Одно из значений опций
 * @param {Boolean} event Вызов события change
 */
Select.prototype.setValue = function(value, event = true) {
    for (let i = 0; i < this.$items.length; ++i) {
        this.$items[i].classList.remove('selected');

        if (this.$items[i].dataset.value == value) {
            this._value = value;
            this._selectedIndex = i;
            this.$selected.innerHTML = this.$items[i].innerHTML;
            this.$items[i].classList.add('selected');
        }
    }

    if (this.$input.value != value) {
        this.$input.value = value;

        if (event) {
            this.emit('change', this._value, this._selectedIndex);
            this.confirm();
        }
    }

    this.emit('select', this._value, this._selectedIndex);
}

/**
 * Подтверждение выбора
 */
Select.prototype.confirm = function() {
    this.$input.dispatchEvent(new Event('change', {
        bubbles: true,
        cancelable: true,
    }));
}

/**
 * Индекс выбранного пункта
 */
Select.prototype.getSelectedIndex = function() {
    return this._selectedIndex;
}

/**
 * Выбор пункта
 * @param {Number}  index Порядковый номер опции
 * @param {Boolean} event Вызов события change
 */
Select.prototype.setSelectedIndex = function(index, event = true) {
    if (this.$items[index]) {
        this.setValue(this.$items[index].dataset.value, event);
    }
}

/**
 * Открытие/закрытие элемента
 */
Select.prototype.toggle = function() {
    if (this.$element.classList.contains('is-opened')) {
        this.close();
    } else {
        this.open();
    }
}

/**
 * Открытие элемента
 */
Select.prototype.open = function() {
    // сохраняем размер родителя, т.к. при position: absolute высота селекта будет 0
    this._updateParentSize();
    this.$element.classList.add('is-opened');

    if (this.$element.classList.contains('is-opened') && !this._outsideClickBind) {
        document.addEventListener('click', this._outsideClickBind = this._outsideClick.bind(this));
    }

    this._simpleBar.recalculate();
    this.emit('open');
}

/**
 * Закрытие элемента
 */
Select.prototype.close = function() {
    this._resetParentSize();
    this.$element.classList.remove('is-opened');
    document.removeEventListener('click', this._outsideClickBind);
    delete this._outsideClickBind;

    this.emit('close');
}

/**
 * Обновление размеров родителя контейнера
 */
Select.prototype._updateParentSize = function() {
    const rect = this.$element.parentNode.getBoundingClientRect();
    const height = [...this.$items].slice(0, 4).reduce((acc, $item) => acc += $item.offsetHeight, 0);

    this.$element.parentNode.style.minWidth  = rect.width + 'px';
    this.$element.parentNode.style.minHeight = rect.height + 'px';

    this.$element.style.position = 'absolute';

    this.$element.parentElement.style.width = `${this.$element.parentElement.offsetWidth}px`;
    this.$element.parentElement.style.height = `${this.$element.parentElement.offsetHeight}px`;

    this.$element.style.height = `${this.$element.offsetHeight}px`;
    this.$element.style.height = `${this.$element.offsetHeight + height}px`;
    this.$itemsWrapper.style.height = `${height}px`;
}

/**
 * Сброс размеров родителя контейнера
 */
Select.prototype._resetParentSize = function() {
    const height = [...this.$items].slice(0, 4).reduce((acc, $item) => acc += $item.offsetHeight, 0);

    setTimeout(() => {
        this.$element.style.position = '';

        this.$element.parentNode.style.minWidth  = '';
        this.$element.parentNode.style.minHeight = '';
        
        this.$element.parentElement.style.width = '';
        this.$element.parentElement.style.height = '';
    }, 300);

    this.$element.style.height = `${this.$element.offsetHeight - height}px`;
    this.$itemsWrapper.style.height = '';
}

/**
 * Клик вне элемента
 */
Select.prototype._outsideClick = function(e) {
    if (this.$element != e.target && !this.$element.contains(e.target)) {
        this.close();
    }
}

/**
 * Клик по одному из пунктов
 * @param  {Element} $item Элемент по которому кликнули
 */
Select.prototype._itemClick = function($item) {
    this.setValue($item.dataset.value);
    this.close();
}

/**
 * Создание скрытого поля
 */
Select.prototype._initHiddenInput = function() {
    if (!this.$input && this.$element.dataset.name) {
        this.$input = document.createElement('input');
        this.$input.type = 'hidden';
        this.$input.name = this.$element.dataset.name;
        this.$element.insertBefore(this.$input, this.$element.firstElementChild);
    }
}

/**
 * Выбранный по умолчанию элемент
 */
Select.prototype._initSelectedIndex = function() {
    let selectedIndex = 0;
    [...this.$items].forEach(($item, i) => {
        if ($item.classList.contains('selected')) {
            selectedIndex = i;
            return;
        }
    });

    this.setSelectedIndex(selectedIndex, false);
}

/**
 * Инициализация полосы прокрутки
 */
Select.prototype._initSimpleBar = function() {
    this._simpleBar = new SimpleBar(this.$itemsWrapper, {
        autoHide: false,
    });
}

Select.prototype.isInit = function() {
    return this.getSelectedIndex() == 0 ? false : true;
}

Select.prototype.reset = function() {
    this.setSelectedIndex(0);
}

Select.make = function(items, options = {}) {
    const $element = createElement(
        `<div class="Select__wrapper">
            <div class="Select">
                <input type="hidden" name="${options.name || ''}">
                <div class="Select-selected-wrapper">
                    <div class="Select-selected"></div>
                    <div class="Select-arrow"></div>
                </div>
                <div class="Select-items">
                    ${items.map(item => `<div class="Select-item" data-value="${item.value}">${item.title}</div>`).join('')}
                </div>
            </div>
        </div>`
    );

    return new Select($element, options);
}

export default Select;
